import React from "react";
import "./../../UaeAttestation/UaeService/UaeService.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
const MalaysiaServiceMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          <p>
            Malaysia Embassy Attestation is required for all Indian-originated
            documents that are to be used in Malaysia. The Attestation process
            is a legalizing procedure in which documents are authenticated by
            the Malaysian Embassy. Documents are validated and attested by
            pertinent government officials and the Malaysian Embassy during the
            procedure.
          </p>
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          <p>
            The Malaysian Embassy has allowed GOODWAY ATTESTATION agency to
            conduct legitimate Malaysia attestation services in Bangalore. We
            offer the best service for obtaining Malaysia document attestation
            (Educational, Non-educational, or Commercial Documents) from the
            Malaysian Embassy.
          </p>
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          <p>
            Malaysian attestation is necessary for a variety of reasons. It is
            unquestionable evidence that you are not just a genuine traveller,
            but also that you are visiting another country with the best of
            intentions. It proves that your documents are authentic and that you
            are allowed to enter the country.
          </p>
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          <p>
            As a result, while you are traveling for work or business, you will
            be able to establish a relationship between the employer and
            employee, or between two businessmen. In the case of students, this
            approach will assure the college or university that you are
            interested in taking a course from a particular institution.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default MalaysiaServiceMain;
